import {
  FilterType,
  OfficeLocation,
  SortType,
} from "../store/actions/eventsActions";
import { useEffect, useState } from "react";

import { Event } from "../types/event";

const useHandleSortEvents = (
  allEvents: Event[],
  eventsSortType: SortType,
  eventsFilterType?: FilterType
) => {
  const [displayedEventsList, setDisplayedEventsList] = useState<Event[]>([]);
  const [displayedFilterCount, setDisplayedFilterCount] = useState<number>(0);

  useEffect(() => {
    let filteredEvents = allEvents;
    let filterCount = 0;

    if (eventsFilterType?.format !== "All") {
      filterCount++;
      filteredEvents = allEvents.filter(
        (event) => event.format === eventsFilterType?.format
      );
    }

    if (eventsFilterType?.office !== OfficeLocation.NEW_ENGLAND) {
      filterCount++;
      filteredEvents = filteredEvents.filter(
        (event) =>
          event.office === OfficeLocation.NEW_ENGLAND ||
          event.office === eventsFilterType?.office
      );
    }

    if (eventsFilterType?.eventTags.length) {
      if (!eventsFilterType?.eventTags.includes("All")) {
        filterCount += eventsFilterType?.eventTags.length;
        filteredEvents = filteredEvents.filter((event) =>
          event.eventTags.some((tag) =>
            eventsFilterType.eventTags.includes(tag)
          )
        );
      }
    }

    const sortedEvents = filteredEvents.slice().sort((a, b) => {
      switch (eventsSortType) {
        case SortType.DATE_SOONEST:
          return a.startDateTime - b.startDateTime;
        case SortType.DATE_FURTHEST:
          return b.startDateTime - a.startDateTime;
        case SortType.ASCENDING:
          return a.title.localeCompare(b.title);
        case SortType.DESCENDING:
          return b.title.localeCompare(a.title);
        case SortType.MOST_SIGNUPS:
          return b.signUpCount - a.signUpCount;
        case SortType.LEAST_SIGNUPS:
          return a.signUpCount - b.signUpCount;
        default:
          return 0;
      }
    });

    setDisplayedEventsList(sortedEvents);
    setDisplayedFilterCount(filterCount);
  }, [eventsSortType, eventsFilterType, allEvents]);

  return { displayedEventsList, displayedFilterCount };
};

export default useHandleSortEvents;
